import request from '../utils/csrf-superagent'; // enhanced superagent to handle jwt-csrf tokens
import config from '../config';
import actions from '../actions/actions';
import brandDeterminationActions from '../actions/brandDetermination';

function getSupportedSites(store) {
    request.get(`/${config.url_prefix}/api/getSupportedSites`)
        .end((error, response) => {
            if (error) {
                store.dispatch(brandDeterminationActions.alertError('ipmob.internal.server.error'));
            } else {
                try {

                    const res = JSON.parse(response.text);
                    const siteName = store.getState().system.siteName;
                    store.dispatch(brandDeterminationActions.getSupportedSitesSuccess(siteName, res.supportedCountries, res.primarySiteMap));
                } catch (exp) {
                    store.dispatch(brandDeterminationActions.alertError('ipmob.error.process.request'));
                }
            }
            store.dispatch(actions.enableLoadOverLay(false));
        });
}

export default getSupportedSites;
